/* eslint-disable max-lines */
/* eslint-disable new-cap */
/* eslint-disable sort-imports */
import $ from 'jquery';
import ko from 'knockout';
import formatCartItems from './formatcartitems';
import { HTTP_STATUS_OK } from '../../../smartpak/httpstatus';
import CartItemsViewModel from '../viewmodels/cartitemsviewmodel';
import CostSummaryViewModel from '../viewmodels/costsummaryviewmodel';
import WishListViewModel from '../viewmodels/wishlistviewmodel';
import FreeShipBannerViewModel from '../viewmodels/freeshipbannerviewmodel';
import customerInfo from '../../../controls/customerinfo';
import perksMessaging from './perksmessaging';
import recentlyViewedProducts from '../../../smartpak/recentlyviewedproducts';
import { tooltipProxy as tooltip } from '../../../smartpak/tooltipproxy';
import shoppingCart from '../api/shoppingcart';
import SmartPakCancellationBannerViewModel from '../viewmodels/cancellationbannerviewmodel';
import { productsOnPage } from '../../../vendor/googletagmanager/events';
import { getUserLocation } from '../../../vendor/dynamicyield/dynamicyield';
import CartSubmitViewmodel from '../viewmodels/cartsubmitviewmodel';
import events from './events';

function httpStatusOk(status) {
    return status === HTTP_STATUS_OK;
}

const cart = {
    _getData: function () {
        return $.when(shoppingCart.getShoppingCartModel(), shoppingCart.getWishList());
    },
    _initializeDynamicYield: function (cartItemsViewModel) {
        window.DY = window.DY || {};

        window.DY.recommendationContext = {
            type: 'CART',
            data: cartItemsViewModel.CartItems().reduce(function (ids, item) {
                var SUPPLY = 2;

                return ids.concat(
                    item.ProductType() === SUPPLY
                        ? item.ProductId().toString()
                        : item.SupplementViewModels().map(function (supplement) {
                            return supplement.ProductId().toString();
                        })
                );
            }, [])
        };

        if (smartPak.pageData) {
            this._addScript(smartPak.pageData.dyDynamicUrl);
            this._addScript(smartPak.pageData.dyStaticUrl);
        }
    },
    _autoShipDetailTooltips: function () {
        $('.atsDetailsTooltip').each(function (index, element) {
            var $tip = $(element);

            tooltip($tip, {
                content: $('#' + $tip.data('content')).html()
            });
        });
    },
    _subscribeToQuantityChanges: function (viewmodels, refreshCart) {
        var WARNING_DELAY_MS = 1500,
            req,
            timeout,
            quantityNumber;

        if (viewmodels && viewmodels.cartItemsViewModel && viewmodels.cartItemsViewModel.CartItems) {
            viewmodels.cartItemsViewModel.CartItems().forEach(
                function (cartItem) {
                    if (cartItem.isSupply) {
                        const showQuantityErrorModal = (max) => {
                            smartPak.ui.modal(
                                $('<div>Must be a value ' + max + ' or under</div>').get(0),
                                {
                                    title: 'Quantity'
                                }
                            );
                        };

                        cartItem.Quantity.subscribe(
                            function (quantity) {
                                if (req) {
                                    req.abort();
                                    clearTimeout(timeout);
                                    timeout = null;
                                }

                                quantityNumber = parseInt(quantity);

                                if (!isNaN(quantityNumber) && quantityNumber > 0) {
                                    if (quantityNumber > cartItem.MaxQuantity()) {
                                        timeout = setTimeout(function () {
                                            showQuantityErrorModal(cartItem.MaxQuantity());

                                            cartItem.Quantity(+(quantity + '').substr(0, 2));
                                        }, WARNING_DELAY_MS);
                                    } else {
                                        req = shoppingCart
                                            .updateQuantityForSupply(
                                                JSON.stringify({
                                                    itemId: cartItem.ItemId(),
                                                    quantity: quantity
                                                })
                                            )
                                            .done(
                                                function (result) {
                                                    if (
                                                        result.Errors.length > 0 &&
                                                        result.Errors[0].Key === 'ItemQuantityError'
                                                    ) {
                                                        showQuantityErrorModal(cartItem.MaxQuantity());
                                                    }

                                                    this._refresh(viewmodels).done(
                                                        function () {
                                                            refreshCart();
                                                            this._subscribeToQuantityChanges(viewmodels, refreshCart);
                                                        }.bind(this)
                                                    );

                                                    this._updateCostSummary();

                                                    customerInfo.refreshCartItemCount();
                                                }.bind(this)
                                            );
                                    }
                                } else {
                                    timeout = setTimeout(function () {
                                        smartPak.ui.modal($('<div>Must be a value of 1 or greater</div>').get(0), {
                                            title: 'Quantity'
                                        });

                                        cartItem.Quantity(1);
                                    }, WARNING_DELAY_MS);
                                }
                            }.bind(this)
                        );
                    }
                }.bind(this)
            );
        }
    },
    _addMoveToWishList: function (cartItemsViewModel, wishListViewModel) {
        function formatData(cartItem) {
            return JSON.stringify({
                itemId: cartItem.ItemId(),
                productId: cartItem.ProductId()
            });
        }

        cartItemsViewModel.moveItemToWishList = cartItemsViewModel.removeOrMoveItem(
            shoppingCart.moveItemToWishList,
            formatData,
            wishListViewModel.addItem.bind(wishListViewModel)
        );
        return cartItemsViewModel;
    },
    _refresh: function (viewmodels) {
        var $document = $(document),
            scrollPosition = $document.scrollTop();

        return shoppingCart.getShoppingCartModel().done(function (data) {
            if (data.Status === HTTP_STATUS_OK) {
                viewmodels.cartItemsViewModel.updateCartItems(
                    formatCartItems(data.Content.CartItems, data.Content.CartUpsell)
                );
                viewmodels.freeShipBannerViewModel.update(data.Content.FreeShippingBanner);

                if (viewmodels.cartSamplesViewModel) {
                    viewmodels.cartSamplesViewModel.update(viewmodels.cartItemsViewModel);
                }
                $document.scrollTop(scrollPosition);
            }
        });
    },
    _addScript: function (url) {
        var script = document.createElement('script');

        script.type = 'text/javascript';
        script.src = url;

        document.getElementsByTagName('body')[0].appendChild(script);
    },
    _toggleValidationMessage: function (shouldShow) {
        const validationMessage = document.getElementById('cartValidationMsg');

        if (shouldShow) {
            validationMessage.classList.remove('jsHide');
        }
    },
    _bindCartSubmitViewModel: function (cartItemsViewModel) {
        ko.applyBindings(new CartSubmitViewmodel(cartItemsViewModel, this._toggleValidationMessage), $('#continue-checkout').get(0));
    },
    _onUserLocation: function (geoFields, viewModel) {
        if (/hawaii|alaska/gi.test(geoFields?.state)) {
            viewModel.canShowEstimatedArrival(false);
        }
    },
    _setupCartItems: function (cartItemsViewModel, wishListViewModel) {
        var viewModel = this._addMoveToWishList(cartItemsViewModel, wishListViewModel);

        getUserLocation().then(geoFields => this._onUserLocation(geoFields, viewModel));

        ko.applyBindings(viewModel, $('#cartItemsDisplay').get(0));
    },
    _setupBanners: function (freeShipBannerViewModel) {
        ko.applyBindings(freeShipBannerViewModel, $('#cartMessaging').get(0));
    },
    _toggleRideAlongMessageVisibility(status){
        const messaging = document.getElementById('cart-messaging-container');
        messaging.style.display = status ? 'block' : 'none';
    },
     _addWishListAddToCart: function (wishListViewModel, inactiveDialog, refreshCart) {
        const addItemToCart = wishListViewModel.addItemToCart;

        wishListViewModel.addItemToCart = (item) => {
            addItemToCart.call(wishListViewModel, item)
                .then(({ Status, Content, inactive, redirectUrl }) => {
                    if (Status === HTTP_STATUS_OK && Content) {
                        $(document).trigger('cartChange');
                        refreshCart();

                        events.addCartItem({
                            id: Content.ProductClassId,
                            sku: Content.ProductId,
                            price: Content.HasDiscounts ? Content.DiscountedUnitPrice : Content.UnitPrice,
                            quantity: Content.Quantity
                        });
                        return;
                    }

                    if (!inactive && redirectUrl) {
                        location.href = redirectUrl;
                        return;
                    }

                    inactiveDialog();
                });
        };
    },
    _updateCostSummary: function (costSummary) {
        if (!this._costSummaryViewModel && costSummary) {
            this._costSummaryViewModel = new CostSummaryViewModel(costSummary);
            ko.applyBindings(this._costSummaryViewModel, $('#costSummary').get(0));
        } else {
            shoppingCart.getCartCostSummary().done(
                function (data) {
                    if (data.Status === HTTP_STATUS_OK) {
                        this._costSummaryViewModel.update(data.Content);
                    }
                }.bind(this)
            );
        }
    },
    _setupCancellationMessaging: function (data) {
        ko.applyBindings(new SmartPakCancellationBannerViewModel(data), $('#cancellationMessaging').get(0));
    },
    perksMessaging: perksMessaging,
    _estimatedArrivalToolips: function () {
        tooltip($('.tooltipTrigger'));
    },
    _inactiveDialog: function () {
        var $modal = $(
            '<div id="promptInactive" class="jsHide"><div class="plm prm ptm">We\'re sorry, but this item is no longer available. Our team would love to help you find a comparable item, so please give us a call at 1-800-461-8898 - we\'re always happy to help!</div></div>'
        ).appendTo('body');

        smartPak.ui.modal($modal.get(0), { title: 'Inactive Item' });
    },
    _bindEvents: function () {
        $('body')
            .on('click', '#loginForm .pwd-toggle-show', function (e) {
                e.preventDefault();
                $('#Password').prop('type', 'text');
                $(e.target).addClass('jsHide');
                $('.pwd-toggle-hide').removeClass('jsHide');
            })
            .on('click', '#loginForm .pwd-toggle-hide', function (e) {
                e.preventDefault();
                $('#Password').prop('type', 'password');
                $(e.target).addClass('jsHide');
                $('.pwd-toggle-show').removeClass('jsHide');
            });
    },
    _getFreeShippBannerViewModel: function (data) {
        return new FreeShipBannerViewModel(data);
    },
    _getCartItemsViewModel: function (
        model,
        customerIsSmartPrimeEligible,
        onUpdateCallback,
        ShowOneTimeShipSmartPakOption
    ) {
        return new CartItemsViewModel(
            model,
            customerIsSmartPrimeEligible,
            onUpdateCallback,
            ShowOneTimeShipSmartPakOption
        );
    },
    _reportProductsOnPage: function (cartItems) {
        const format = item => {
            return {
                name: item.ProductClassName.trim(),
                productClassId: item.ProductClassId,
                itemId: item.ProductClassId + 10000,
                sku: item.ProductId
            };
        };

        productsOnPage(cartItems.reduce((arr, item) => {
            if (/1|3/gi.test(item.ProductType)) {
                item.SupplementViewModels.forEach(supplement => {
                    arr.push(format(supplement));
                });

                return arr;
            }

            arr.push(format(item));

            return arr;
        }, []));
    },
    init: function () {
        var wishListViewModel = new WishListViewModel([]);
        ko.applyBindings(wishListViewModel, $('#wishlistDisplay').get(0));

        this._getData().done(
            function (cartData, wishListData) {
                if (httpStatusOk(cartData[0].Status) && httpStatusOk(wishListData[0].Status)) {
                    var onCartRefresh = function () {
                        this._autoShipDetailTooltips();
                        this._estimatedArrivalToolips();
                    }.bind(this),
                        refreshCart = function () {
                            this._refresh(viewmodels).done(
                                function () {
                                    requestAnimationFrame(
                                        function () {
                                            onCartRefresh();
                                            this._subscribeToQuantityChanges(viewmodels, onCartRefresh);
                                        }.bind(this)
                                    );
                                }.bind(this)
                            );

                            this._updateCostSummary();
                        }.bind(this),
                        data = cartData[0].Content;

                    wishListViewModel.update(wishListData[0].Content);

                    // eslint-disable-next-line one-var
                    var freeShipBannerViewModel = this._getFreeShippBannerViewModel(data.FreeShippingBanner),
                        cartItemsViewModel = this._getCartItemsViewModel(
                            { CartItems: formatCartItems(data.CartItems, data.CartUpsell) },
                            data.FreeShippingBanner.CustomerIsSmartPrimeEligible,
                            refreshCart,
                            data.ShowOneTimeShipSmartPakOption
                        ),
                        viewmodels = {
                            cartItemsViewModel: cartItemsViewModel,
                            freeShipBannerViewModel: freeShipBannerViewModel,
                            wishListViewModel: wishListViewModel
                        };

                    this._initializeDynamicYield(viewmodels.cartItemsViewModel);
                    this._bindCartSubmitViewModel(viewmodels.cartItemsViewModel);
                    this._setupCartItems(viewmodels.cartItemsViewModel, viewmodels.wishListViewModel);
                    this._setupBanners(viewmodels.freeShipBannerViewModel);
                    this._addWishListAddToCart(viewmodels.wishListViewModel, this._inactiveDialog, refreshCart);
                    this._setupCancellationMessaging(data.SmartPakCancellationBannerViewModel);
                    this._estimatedArrivalToolips();
                    this._updateCostSummary(data.CostSummary);
                    this._autoShipDetailTooltips();
                    this._subscribeToQuantityChanges(viewmodels, refreshCart);
                    recentlyViewedProducts.loadBvReviewStars('.cartReviewStars');

                    this._reportProductsOnPage(data.CartItems);
                    this._toggleRideAlongMessageVisibility(freeShipBannerViewModel.CartHasAddOnItemsOnlyAndSubTotalLessThanSeventyFive() && freeShipBannerViewModel.CustomerIsSmartPrimeEligible());
                    
                    freeShipBannerViewModel.CartHasAddOnItemsOnlyAndSubTotalLessThanSeventyFive.subscribe(() => {
                        this._toggleRideAlongMessageVisibility(freeShipBannerViewModel.CartHasAddOnItemsOnlyAndSubTotalLessThanSeventyFive() && freeShipBannerViewModel.CustomerIsSmartPrimeEligible());
                    });
                    
                    getUserLocation().then(location => {
                        if (location.state === 'California') {
                            cartItemsViewModel.showProp65Warnings(true);
                        }
                    });
                }


                if (smartPak.cdProfileCookie && smartPak.cdProfileCookie.qualifiesForSuggestions) {
                    import('./smartsuggestions').then(({ default: cartSmartSuggestions }) => cartSmartSuggestions.init());
                }

                $(document).on(
                    'cartChange',
                    function () {
                        this._updateCostSummary();

                        customerInfo.refreshCartItemCount();

                        this.perksMessaging();
                    }.bind(this)
                );
            }.bind(this)
        );

        this._bindEvents();
    }
};

export default cart;